<div class="flex flex-col gap-4">
  <div class="flex items-start gap-4">
    <div class="flex flex-col gap-4 h-full justify-start flex-1 min-w-0">
      <div class="flex items-center gap-4">
        <div class="bg-white rounded-lg">
          <p-button [label]="'Back'"
                    [severity]="'secondary'"
                    [outlined]="true"
                    [icon]="'fa fa-chevron-left'"
                    (onClick)="goBack()"
          ></p-button>
        </div>

        <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">
          {{ 'Travel Allowance Finalisation for ' + taSubmission()?.taNumber }}
        </div>



        <div class="flex gap-1 items-center">
          @if (travellersLength() > 1) {
            <i class="fa-solid fa-users"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name + ' (+' + (taSubmission()!.travellerCount! - 1) + ')'}}</div>
          } @else {
            <i class="fa-solid fa-user"></i>
            <div class="justify-start text-text-color text-xl font-semibold font-['Inter']">{{taSubmission()?.primaryTraveller?.details?.name}}</div>
          }
        </div>
      </div>

      <div class="justify-start text-text-color text-sm font-semibold font-['Inter'] leading-4">{{'Travel Date: ' + ((taSubmission()?.startDate | date: 'dd/MM/yy') ?? '-') }}</div>

      <div class="justify-start text-text-color text-sm font-semibold font-['Inter']">
        {{ "Status: " +  toTAStatusText(this.store.taSubmission()?.status ?? '-') }}
      </div>

      @if (isComplianceFinalised()) {
        <div class="w-full justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">Compliance will finalise this day trip once the payment is processed.</div>
      } @else if (!canFinalise()) {
        <div class="w-full justify-start text-text-color text-sm font-normal font-['Inter'] leading-4">TA requires finalisation by Finance Unit.</div>
      }

      <ta-approvals-table [taSubmission]="taSubmission()" heading="Approvals"></ta-approvals-table>
    </div>

    <div class="flex flex-col gap-2 items-end">
      <ta-cost-bubble title="Approved TA Value" [value]="originalTaValue()" severity="outlined"></ta-cost-bubble>
      <ta-cost-bubble title="Acquitted TA Value" [value]="currentTaValue()" severity="outlined"></ta-cost-bubble>
      <ta-cost-bubble title="Change in TA Value" [value]="acquittedValueChange()" [severity]="acquittedValueChange() === 0 ? 'text' : 'outlined'" [signed]="true"></ta-cost-bubble>
      <ta-cost-bubble title="Finalisation Payment Due" [value]="finalisationPaymentDue()" severity="primary"></ta-cost-bubble>
      <div class="w-full h-[1px] bg-surface-200"></div>
      @if (isPrePaid()) {
        <ta-cost-bubble title="Prepayment Component" titleIcon="fa-regular fa-piggy-bank text-green-700" [value]="prepaymentComponent()" severity="success"></ta-cost-bubble>
        @if (overpaymentMade() > 0) {
          <ta-cost-bubble title="Overpayment Made" titleIcon="fa-regular fa-piggy-bank text-[#DC2626]" [value]="overpaymentMade()" severity="danger"></ta-cost-bubble>
        }
      }
      <ta-cost-bubble title="Day Trip Component" [value]="dayTripComponent()" severity="purple"></ta-cost-bubble>
    </div>
  </div>

  @if (showDayTripBreakdown()) {
    <manage-ta-day-trip-payment-table [rows]="dayTripPaymentRows()"></manage-ta-day-trip-payment-table>
  }

  <itinerary-difference-comparison [showTravellerPortions]="!showDayTripBreakdown()"></itinerary-difference-comparison>

  @if (isDeductionProcessed()) {
    <div class="w-full h-[1px] bg-surface-200"></div>
    <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">
      Overpayment deduction is processed.
    </div>
  }

  <manage-ta-payment-actions></manage-ta-payment-actions>

  <div class="w-full h-[1px] bg-surface-200"></div>

  <div class="w-full flex gap-4">
    @if (canFinalise()) {
      <div class="flex flex-col gap-4">
        @if (!isComplianceFinalised()) {
          <p-button [severity]="'primary'" styleClass="w-64" (onClick)="confirmFinalise('finalise')">
            <i class="pi pi-check-circle pl-[1px]"></i>
            <span class="flex-1">Finalise TA</span>
          </p-button>
        }
        <div class="bg-white rounded-lg">
          <p-button [severity]="'secondary'" outlined styleClass="w-64" (onClick)="confirmFinalise('withhold')">
            <i class="pi pi-exclamation-circle pl-[1px] text-surface-700"></i>
            <span class="flex-1">Withhold Finalisation</span>
          </p-button>
        </div>
      </div>
    }
  </div>
</div>
